<template>
  <div id="app">
    <div class="wrap" :class="{positions: helperHeightYn}">
      <HelperHeight :helperHeightYn="helperHeightYn" />

      <div class="main sco">
        <header class="main__header">
          <img src="@/assets/images/user/sco_order_banner.png" class="scheduleComp" style="z-index: 5; height: 100%" />
        </header>
        <!-- 이용가이드역역 -->
        <div class="guide-area" :style="{background: 'url(' + guideImg + ')'}"></div>
        <div class="main__body">
          <div class="content">
            <div class="cart-lst" :class="{'for-kr': !isSimpleToken}">
              <div class="hdr-fix">
                <span class="txt">{{ $t('User.Sco.msg1') }}</span>
                <span class="txt">{{ $t('User.Sco.msg2') }}</span>
                <span class="txt">{{ $t('User.Sco.msg3') }}</span>
                <span class="txt">{{ $t('User.Sco.msg4') }}</span>
                <span class="txt">{{ $t('User.Sco.msg5') }}</span>
              </div>
              <div class="scroll-area" id="basketScroll">
                <!-- item one -->
                <div class="no-data" v-if="baskets.length == 0">
                  <i class="ico-nodata"></i>
                  <span class="txt">{{ $t('User.Sco.msg6') }}</span>
                </div>

                <div name="basketItem" class="w-box-row on" v-for="(item, i) in baskets" :key="i">
                  <span class="ico-staff-chk" v-if="item.HARM_YN == 'Y'"></span>
                  <span class="nth01">{{ item.DIS_ITEM_NM }}</span>
                  <span class="nth02">
                    <input type="checkbox" class="toggle" :id="i" hidden disabled :checked="item.EAT_IN" />
                    <label :for="i" class="toggle-switch" @mouseup="eatIn(i)">
                      <span class="toggle-button"></span>
                    </label>
                  </span>
                  <span class="nth03">{{ taxDetail(item) }}%</span>
                  <span class="nth04 amount-txt">
                    <button
                      class="btn-minus btn-minus--sm btn-anim"
                      v-show="quantityYn"
                      @mouseup="
                        if (item.SALES_QTY > 1) item.SALES_QTY--;
                        changeQty(i, item.SALES_QTY);
                        $logInfo(`Basket Qty Change DIS_ITEM_CD : ${item.DIS_ITEM_CD}, Qty : ${item.SALES_QTY}`);
                      "
                    >
                      빼기
                    </button>
                    <span>{{ item.SALES_QTY }}</span>
                    <button
                      class="btn-plus btn-plus--sm btn-anim"
                      v-show="quantityYn"
                      @mouseup="
                        if (item.SALES_QTY > 0) item.SALES_QTY++;
                        changeQty(i, item.SALES_QTY);
                        $logInfo(`Basket Qty Change DIS_ITEM_CD : ${item.DIS_ITEM_CD}, Qty : ${item.SALES_QTY}`);
                      "
                    >
                      더하기
                    </button>
                  </span>
                  <span class="nth05">{{ $displayUprc(item.SALES_QTY * $detailUprc(item)) }}</span>
                  <button
                    class="btn-dustbin"
                    @mouseup="
                      delBasket(i);
                      $logInfo(`Basket Delete DIS_ITEM_CD : ${item.DIS_ITEM_CD}`);
                    "
                  >
                    삭제
                  </button>
                  <span class="lst-tag lst-tag--red" v-if="item.EVNT_ITEM_CD != '' && item.EVNT_ITEM_CD != null && item.DC_ABLE_YN === 'Y'">
                    <span>SALE</span>
                  </span>
                  <span class="lst-tag lst-tag--blue" v-if="false">
                    <span>1+1</span>
                  </span>
                </div>
                <!-- //item one -->
              </div>

              <button class="btn--rnd-lg up" :disabled="basketItemCnt < 6" @mouseup="this.basketScrollMove(-50)">
                <i class="ico-arr-u--lg">위</i>
              </button>
              <button class="btn--rnd-lg down" :disabled="basketItemCnt < 6" @mouseup="this.basketScrollMove(+50)">
                <i class="ico-arr-d--lg">아래</i>
              </button>
            </div>

            <div class="preset-area">
              <!-- 바코드 직접 입력 -->
              <div
                id="category"
                class="category"
                :style="
                  kioskClas.filter((clas) => kioskItem.some((item) => item.KOS_CLASS_CD == clas.KOS_CLASS_CD)).length < 5
                    ? 'display:contents;'
                    : 'display:flex;'
                "
              >
                <div style="display: flex">
                  <div class="w-box btn-anim" @mouseup="barcodeYn = true">
                    <span class="ico-area ico-barcode" style="margin-bottom: 0.1em"></span>
                    <span class="txt-area" style="font-size: 1.2em">{{ $t('User.Sco.msg7') }}</span>
                  </div>
                  <!-- 장바구니 -->
                  <template v-for="clas in kioskClas">
                    <div
                      v-if="kioskItem.filter((item) => item.KOS_CLASS_CD == clas.KOS_CLASS_CD).length > 0"
                      class="w-box btn-anim"
                      @mouseup="
                        kosClassCd = clas.KOS_CLASS_CD;
                        basketYn = true;
                      "
                      :key="clas"
                    >
                      <span
                        class="ico-area ico-cart"
                        :style="{background: 'url(' + clas.KOS_MENU_IMG_FILE_URL == null ? replaceToDefaultImg : clas.KOS_MENU_IMG_FILE_URL + ')'}"
                      ></span>
                      <span class="txt-area">{{ $t('User.Sco.msg12') }}</span>
                    </div>
                  </template>
                </div>
              </div>

              <button
                v-if="kioskClas.filter((clas) => kioskItem.some((item) => item.KOS_CLASS_CD == clas.KOS_CLASS_CD)).length >= 5"
                class="btn--rnd-md left"
                @mouseup="moveheader(-50)"
              >
                <i class="ico-arr-l">좌</i>
              </button>
              <button
                v-if="kioskClas.filter((clas) => kioskItem.some((item) => item.KOS_CLASS_CD == clas.KOS_CLASS_CD)).length >= 5"
                class="btn--rnd-md right"
                @mouseup="moveheader(50)"
              >
                <i class="ico-arr-r">우</i>
              </button>
            </div>
          </div>
        </div>
        <div class="main__footer">
          <div class="total-area">
            <div class="box-gray no-btn up">
              <dl class="total-price">
                <dt>{{ $t('User.Sco.msg8') }}</dt>
                <dd>{{ totalQty }}</dd>
              </dl>
            </div>
            <div class="box-gray no-btn">
              <dl class="total-price--type02">
                <dt>{{ $t('User.Sco.msg9') }}</dt>
                <dd>{{ totalUprc }}</dd>
                <dt>{{ $t('User.Sco.msg10') }}</dt>
                <dd>{{ totalDiscount }}</dd>
                <dt>{{ $t('User.Sco.msg11') }}</dt>
                <!-- 테스트 코드 -->
                <dd class="point ft--3xlg">{{ totalUprc }}</dd>
              </dl>
            </div>
          </div>
          <div class="btn-area">
            <!--도움기능-->
            <button class="btn--line btn--md btn-anim" @mouseup="helperYn = true">
              <i class="ico-helper ico-sm"></i><span style="font-size: 1.4em">{{ $t('User.Order.msg11') }}</span>
            </button>
            <!-- 장바구니 삭제 -->
            <button class="btn btn--line btn--square-lg btn--shadow btn-anim" :disabled="baskets.length == 0" @mouseup="basketDelYn = true">
              <i class="ico-delete-48"></i><span style="font-size: 1.4em">{{ $t('User.Order.msg15') }}</span>
            </button>
            <!-- 홈으로 -->
            <button class="btn btn--square-lg btn--shadow btn--violet btn-anim" @mouseup="alertHomeYn = true">
              <i class="ico-home-w"></i><span style="font-size: 1.4em">{{ $t('User.Order.msg9') }}</span>
            </button>
            <!-- 주문 -->
            <button class="btn btn--shadow btn--2xlg btn--color btn-anim" :disabled="baskets.length == 0" @mouseup="harmCheck()">
              {{ $t('User.Order.msg17') }}
            </button>
          </div>
        </div>
      </div>

      <BasketDel @closeBasket="basketDelYn = false" @setDel="basketClear()" v-if="basketDelYn" />
      <Helper
        @setDarkYn="
          $store.commit('setDarkModeYn');
          helperYn = false;
        "
        @setHelper="
          helperYn = false;
          staffCallFinishYn = true;
        "
        @setHelperHeight="
          $store.commit('setHelperHeightYn');
          helperYn = false;
        "
        @closeHelper="helperYn = false"
        :helperYn="helperYn"
      />

      <StaffCall
        @closeStaffCall="staffCallYn = false"
        @setStaffCall="
          staffCallYn = false;
          staffCallFinishYn = true;
        "
        :staffCallYn="staffCallYn"
      />
      <StaffCallFinish @closeStaffCallFinish="staffCallFinishYn = false" :staffCallFinishYn="staffCallFinishYn" />

      <AlertHome :alertHomeYn="alertHomeYn" @closeAlert="alertHomeYn = false" @setHome="$router.push('/user/idle')" />
      <Basket @setInputBaskets="setInputBaskets" :kosClassCd="kosClassCd" @closeBasket="basketYn = false" v-if="basketYn" :currUnitText="currUnitText" />
      <Barcode v-if="barcodeYn" @setBarcode="setBarcode" @closeBarcode="barcodeYn = false" />
      <AlertSuccess v-if="alertSuccessYn" :text="alertText" @setYes="alertClose()" />
      <AlertSuccess v-if="alertSuccessYn2" :text="alertText" @setYes="alertClose(1)" />
      <AdminLogin v-if="adminLoginYn" @closeAdminLogin="adminLoginYn = false" @setBasketOrder="setBasketOrder" />
    </div>
  </div>
</template>
<script>
//높낮이 모드
import helperHeight from '@/components/common/HelperHeight.vue';
//장바구니 삭제
import basketDel from '@/components/modal/alert/BasketDel.vue';
//장바구니
import basket from '@/components/modal/sco/Basket.vue';
//바코드 입력
import barcode from '@/components/modal/sco/Barcode.vue';
//편의기능
import helper from '@/components/modal/Helper.vue';
import staffCall from '@/components/modal/StaffCall.vue';
import staffCallFinish from '@/components/modal/StaffCallFinish.vue';
import alertHome from '@/components/modal/alert/AlertHome.vue';
//음성
import audioHelper from '@/js/common/audioHelper.js';
//깊은복사
import _ from 'lodash';
//컨텐츠 스케줄러
import SchedulerHelper from '@/js/common/schedulerHelper.js';

//기타
import chargeHelper from '@/js/common/chargeHelper.js';
import alertSuccess from '@/components/modal/alert/AlertSuccess.vue';
import adminLogin from '@/components/modal/admin/AdminLogin.vue';

let scheduler = null;
export default {
  name: 'sco',
  methods: {
    alertClose(type) {
      this.alertSuccessYn = false;
      this.alertSuccessYn2 = false;
      if (type == 1) this.adminLoginYn = true;
    },
    // 상품 이미지 로딩 실패 시 기본 이미지 표시
    replaceToDefaultImg(e) {
      e.target.src = require('@/assets/images/common/no-image.png');
    },
    //개수 변경
    changeQty(num, qty) {
      this.baskets[num].SALES_QTY = qty;
    },
    //바코드 입력
    setBarcode(barcode) {
      this.getItemDetail(barcode);
      this.barcodeYn = false;
    },
    //세금 상세
    taxDetail(item) {
      let tax = this.taxRate;
      //면세/영세 제외
      if (item.TAX_FLG_CD !== 1) {
        tax = 0;
      }

      //세금 미포함 상품
      if (item.TAX_FLG_CD === 1 && !this.isTaxIncluded) {
        //일본 경감 세율 적용
        if (item.TAX_RDC_FLG_CD == '01') {
          tax = item.EAT_IN ? this.taxRate : this.reducedTaxRate;
        } else {
          //경감세율 미적용
          tax = taxRate;
        }
      }

      return tax;
    },
    //장바구니 전체 삭제
    basketClear() {
      this.$logInfo(`Basket All Delete`);
      this.baskets = [];
      this.basketDelYn = false;
    },
    //단품 삭제
    delBasket(num) {
      this.baskets.splice(num, 1);
    },
    //이트인
    eatIn(i) {
      this.baskets[i].EAT_IN = this.baskets[i].EAT_IN ? false : true;
    },
    //스크롤 맨끝으로 이동
    basketScrollToEnd() {
      var bscroll = document.getElementById('basketScroll');
      bscroll.scrollTop = bscroll.scrollHeight;
    },
    //스크롤 이동
    basketScrollMove(moveY) {
      var bscroll = document.getElementById('basketScroll');
      bscroll.scrollTop += moveY;

      this.scrollTop = bscroll.scrollTop;
      this.height = bscroll.clientHeight;
      this.scrollHeight = bscroll.scrollHeight;
    },
    //상품 조회
    getItemDetail(barcode) {
      let index = this.kioskItem.findIndex((item) => {
        return item.DIS_ITEM_CD === barcode;
      });

      if (index == -1) {
        if (this.$i18n.locale == 'jp') {
          this.alertText = '存在しないバーコードです。';
        } else if (this.$i18n.locale == 'ko') {
          this.alertText = '존재하지 않는 바코드입니다.';
        } else if (this.$i18n.locale == 'en') {
          this.alertText = 'Barcode does not exist.';
        } else if (this.$i18n.locale == 'cn') {
          this.alertText = '不存在的条形码。';
        } else if (this.$i18n.locale == 'tw') {
          this.alertText = '不存在的條形碼。';
        }
        this.alertSuccessYn = true;
        return false;
      }

      let item = _.cloneDeep(this.kioskItem[index]);

      if (this.$i18n.locale == 'jp') {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_JP;
      } else if (this.$i18n.locale == 'ko') {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_KO;
      } else if (this.$i18n.locale == 'en') {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_EN;
      } else if (this.$i18n.locale == 'cn') {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_CN;
      } else if (this.$i18n.locale == 'tw') {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_TW;
      }
      item.SALES_QTY = 1;
      this.setBaskets(item);
    },
    //바코드 상품 장바구니 담기
    setBaskets(prd) {
      let basketYn = true;
      this.baskets.forEach((item) => {
        if (item.DIS_ITEM_CD === prd.DIS_ITEM_CD) {
          basketYn = false;
          item.SALES_QTY++;
        }
      });
      if (basketYn) {
        this.baskets.push(prd);
      }

      this.menuPersonalYn = false;
      this.basketKey++;
      this.$store.dispatch('setOrgBaskets', this.baskets);

      setTimeout(() => {
        this.basketScrollToEnd();
      }, 0);
    },
    //상품 선택 장비구니 담기
    setInputBaskets(prd) {
      let basketYn = true;
      this.baskets.forEach((item) => {
        if (item.DIS_ITEM_CD === prd.DIS_ITEM_CD) {
          basketYn = false;
          item.SALES_QTY = item.SALES_QTY + prd.SALES_QTY;
        }
      });
      if (basketYn) {
        this.baskets.push(prd);
      }
      this.$store.dispatch('setOrgBaskets', this.baskets);
      this.basketYn = false;
      setTimeout(() => {
        this.basketScrollToEnd();
      }, 0);
    },
    moveheader(movenum) {
      var category = document.getElementById('category');
      category.scrollLeft += movenum;
    },
    harmCheck() {
      let harmflag = false;
      this.baskets.forEach((basket) => {
        if (basket.HARM_YN == 'Y') harmflag = true;
      });

      if (harmflag) {
        if (this.$i18n.locale == 'jp') {
          this.alertText = '成人認証が必要な商品が含まれています。\n\nスタッフ呼出しをしてください。';
        } else if (this.$i18n.locale == 'ko') {
          this.alertText = '성인인증이 필요한 물품이\n 포함되어 있습니다.\n\n직원을 호출해주세요.';
        } else if (this.$i18n.locale == 'en') {
          this.alertText = 'Contains items that require adult verification. \n\nPlease call a staff member.';
        } else if (this.$i18n.locale == 'cn') {
          this.alertText = '包含需要成人验证的物品。\n\n请致电工作人员。';
        } else if (this.$i18n.locale == 'tw') {
          this.alertText = '包含需要成人驗證的物品。\n\n請致電工作人員。';
        }
        this.alertSuccessYn2 = true;
        return false;
      } else {
        this.setBasketOrder();
      }
    },
    //주문
    setBasketOrder() {
      let itemList = new Array();
      const posConfig = this.$store.getters.getPosConfig.posConfig;
      this.baskets.forEach((basket) => {
        let itemName;
        if (posConfig.defaultLanguage == 'KO') itemName = basket.DIS_ITEM_NM_KO;
        else if (posConfig.defaultLanguage == 'JP') itemName = basket.DIS_ITEM_NM_JP;
        else if (posConfig.defaultLanguage == 'EN') itemName = basket.DIS_ITEM_NM_EN;
        else if (posConfig.defaultLanguage == 'CH') itemName = basket.DIS_ITEM_NM_CN;
        else if (posConfig.defaultLanguage == 'TW') itemName = basket.DIS_ITEM_NM_TW;

        // 행사 정보
        let eventItem = new Array();
        if (basket.EVNT_ITEM_CD != '' && basket.EVNT_ITEM_CD != null) {
          let event = {
            EVNT_CD: basket.EVNT_CD,
            EVNT_NM: basket.EVNT_NM,
            EVNT_KEY_TYPE: basket.EVNT_KIND_CD,
            EVNT_FLG_CD: basket.EVNT_FLG_CD,
            DC_FLG_CD: basket.EVNT_DC_FLG_CD,
            DC_ITEM_QTY: basket.SALES_QTY,
            DC_AMT: basket.EVNT_DC_AMT,
            EVNT_ITEM_CD: basket.EVNT_ITEM_CD,
            DC_RATE: basket.EVNT_DC_AMT,
            EVNT_FROM_DATE: basket.EVNT_FROM_DATE,
            EVNT_END_DATE: basket.EVNT_END_DATE,
            TIME_SALE_YN: basket.TIME_SALE_YN,
            TIME_SALE_FROM_TIME: basket.TIME_SALE_FROM_TIME,
            TIME_SALE_END_TIME: basket.TIME_SALE_END_TIME,
          };
          eventItem.push(event);
        }

        let item = {
          ITEM_CD: basket.DIS_ITEM_CD,
          ITEM_NM: basket.DIS_ITEM_NM,
          ORG_ITEM_NM: itemName,
          CLAS_L_CD: basket.CLAS_L_CD,
          CLAS_M_CD: basket.CLAS_M_CD,
          CLAS_S_CD: basket.CLAS_S_CD,
          TAX_FLG_CD: basket.TAX_FLG_CD,
          TAX_RDC_FLG_CD: basket.TAX_RDC_FLG_CD,
          NRML_UPRC: basket.SALE_UPRC,
          SALES_QTY: basket.SALES_QTY,
          SALES_UPRC: basket.SALE_UPRC,
          ORG_SALES_UPRC: basket.SALE_UPRC,
          DC_ABLE_YN: basket.DC_ABLE_YN,
          DC_AMT: 0.0,
          SALES_AMT: 0,
          VAT_AMT: 0,
          VAT_RATE: basket.TAX_RATE,
          SVC_AMT: 0,
          OPTIONITEM: [],
          SUPY_UPRC: basket.SUPY_UPRC,
          MG_RATE: basket.MG_RATE,
          EVENTITEM: eventItem,
        };
        itemList.push(item);
      });

      let jsonObj = {
        ITEMLIST: itemList,
        EXTRA: {
          ORDER_TYPE: this.$store.getters.getOrderType,
        },
      };

      let tranObj = _.cloneDeep(jsonObj);

      // 상품 가격 계산 (상품할인 행사 포함)
      chargeHelper.calculate(tranObj, posConfig);

      // 영수증 금액 할인 행사 계산
      if (this.receiptDiscount != null) {
        chargeHelper.receipt(tranObj, posConfig, this.receiptDiscount);
      }

      tranObj.ITEMLIST.forEach((basket) => {
        basket.TOTAL_UPRC = basket.SALES_UPRC * basket.SALES_QTY;
      });

      this.$store.dispatch('setBaskets', tranObj);

      this.$logInfo(`Payment Start Tran : ${JSON.stringify(tranObj)}`);
      this.$router.replace('/user/payment');
    },
  },
  beforeMount() {},
  mounted() {
    //주문화면 광고
    var currentUrl = window.location.pathname;

    let that = this;
    scheduler = new SchedulerHelper({
      tag: 'ORDER',
      targetId: 'scheduleArea',
      imageClass: '',
      videoClass: '',
      currentUrl: currentUrl,
      scheduleData: that.topAds,
    });
    scheduler.startSchedule();

    //장바구니 재생성
    if (this.$store.getters.getOrgBaskets != null) this.baskets = this.$store.getters.getOrgBaskets;

    //음성
    try {
      //this.audio.play(); // 20230406 HSSHIN Audio 재생
      audioHelper.playAudio('00101', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
    } catch (ex) {
      console.error(ex);
    }

    //고대비
    this.$changeDarkMode(this.darkModeYn);
    //버튼 애니메이션
    this.$showButtonAnimation();

    //언어 변경
    if (this.$i18n.locale == 'jp') {
      this.guideImg = require('@/assets/images/user/sco_banner_jp.webp');
      this.kioskClas.forEach((clas) => {
        clas.KOS_MENU_NM = clas.KOS_MENU_NM_JP;
      });
    } else if (this.$i18n.locale == 'ko') {
      this.guideImg = require('@/assets/images/user/sco_banner_ko.webp');
      this.kioskClas.forEach((clas) => {
        clas.KOS_MENU_NM = clas.KOS_MENU_NM_KO;
      });
    } else if (this.$i18n.locale == 'en') {
      this.guideImg = require('@/assets/images/user/sco_banner_en.webp');
      this.kioskClas.forEach((clas) => {
        clas.KOS_MENU_NM = clas.KOS_MENU_NM_EN;
      });
    } else if (this.$i18n.locale == 'cn') {
      this.guideImg = require('@/assets/images/user/sco_banner_zh_cn.webp');
      this.kioskClas.forEach((clas) => {
        clas.KOS_MENU_NM = clas.KOS_MENU_NM_CN;
      });
    } else if (this.$i18n.locale == 'tw') {
      this.guideImg = require('@/assets/images/user/sco_banner_zh_tw.webp');
      this.kioskClas.forEach((clas) => {
        clas.KOS_MENU_NM = clas.KOS_MENU_NM_TW;
      });
    }

    //iframe에서 보내는 message 처리
    // window.onmessage = (event) => {
    //   console.log("여기");
    //   // 바코드
    //   if (event.data.indexOf('sco') >= 0) {
    //     let barcode = event.data.replace("sco","");
    //     this.getItemDetail(barcode);
    //   }
    // };
  },

  data() {
    return {
      // socket: io('localhost:3000', {
      //   transports: ['websocket'],
      //   withCredentials: true,
      // }),
      basketDelYn: false,
      darkModeYn: this.$store.getters.getDarkModeYn,
      helperYn: false,
      staffCallYn: false,
      staffCallFinishYn: false,
      alertHomeYn: false,
      scrollTop: 0,
      scrollHeight: 0,
      height: 0,
      baskets: [],
      //화폐단위
      currUnitText: this.$store.getters.getCurrUnitText,
      //부가세율
      taxRate: this.$store.getters.getPosConfig.posConfig.taxRate,
      //경감세율
      reducedTaxRate: this.$store.getters.getPosConfig.posConfig.reducedTaxRate,
      //세금 판매가 포함 여부
      isTaxIncluded: this.$store.getters.getPosConfig.posConfig.isTaxIncluded,
      //소수점
      decimalPlace: this.$store.getters.getPosConfig.posConfig.decimalPlace,
      //금액 계산 방식 (반올림-round/절상-ceil/절하-floor)
      amountRoundType: this.$store.getters.getPosConfig.posConfig.amountRoundType,
      basketYn: false,
      //수량 조절 여부
      quantityYn: false,
      //국내향 일본향 true = 일본 fals = 국내
      isSimpleToken: this.$store.getters.getIsSimpleToken,
      barcodeYn: false,
      kosClassCd: '',
      kioskClas: this.$store.getters.getMasterData.TB_MST_KIOSK_CLAS,
      kioskItem: this.$store.getters.getKioskItem,
      alertSuccessYn: false,
      alertSuccessYn2: false,
      alertText: '',
      guideImg: '',
      receiptDiscount: this.$store.getters.getReceiptDiscount,
      adminLoginYn: false,
    };
  },
  components: {
    BasketDel: basketDel,
    HelperHeight: helperHeight,
    Helper: helper,
    StaffCall: staffCall,
    StaffCallFinish: staffCallFinish,
    AlertHome: alertHome,
    Basket: basket,
    Barcode: barcode,
    AlertSuccess: alertSuccess,
    AdminLogin: adminLogin,
  },
  computed: {
    basketItemCnt: function () {
      let arr = this.baskets.filter((item, prd) => this.baskets.indexOf(item) === prd);
      return arr.length;
    },
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    helperHeightYn() {
      return this.$store.getters.getHelperHeightYn;
    },
    topAds() {
      if (this.$store.getters.getMasterData.TB_MST_CUST_DISP == null) return null;
      const date = new Date();
      //let now = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      return this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.DISP_AREA == '05').filter(
        (item) => this.$strToDate(item.FROM_TIME, item.END_TIME, 0) <= date < this.$strToDate(item.FROM_TIME, item.END_TIME, 1)
      );
    },
    totalDiscount() {
      let sum = 0;
      return this.$displayUprc(sum);
    },
    totalUprc() {
      let sum = 0;
      this.baskets.forEach((item) => {
        sum += item.SALES_QTY * this.$detailUprc(item);
      });

      return this.$displayUprc(sum);
    },
    totalQty() {
      let sum = 0;
      this.baskets.forEach((item) => {
        sum += Number(item.SALES_QTY);
      });

      return sum;
    },
  },
  watch: {
    darkMode(value) {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
  unmounted() {
    //this.scannerEnd();
    //this.socket.off('SCAN');
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/main.css" scoped></style>
<style src="@/assets/css/user/pages/table.css" scoped></style>
<style src="@/assets/css/user/pages/sco.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/main-dark.css" scoped></style>
<style src="@/assets/css/user/dark/sco-dark.css" scoped></style>
<style scoped>
.category {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: scroll;
  margin: 0 4.5em;
  margin-top: 2em;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.category::-webkit-scrollbar {
  display: none;
}

.scheduleArea {
  height: 15.5vh;
}

/* @media (-webkit-device-pixel-ratio: 1.25) {
  .w-box.btn-anim {
    zoom: 1.2;
  }
} */
</style>
